import React, {useEffect, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import parse from 'html-react-parser';
import {FormControl, FormGroup, Grid, InputLabel, TextField} from "@material-ui/core";
import {FormDialog, LabelledPaper, Text} from "../../../controls";
import {isHTML} from "../../../functions/TemplateHelperFunctions";
import StringToJSX from "../../../functions/StringToJsx";

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}

const ViewSourceMessageDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const classes = props.classes;

  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Source Message',
  });

  useEffect(()=> {
    const open = async (record) => {
      const uld = record.uldNumber;
      const markedRecord = {...record, messageContent: `<pre><span>${record.messageContent.trim().replaceAll(uld, `<mark>${uld}</mark>`)}</pre></span>`};

      setDialogStates({...dialogStates, showDialog:true, record: markedRecord});
    }
    eventBus.bind("ViewSourceMessageDialog.open", open);

    return () => {
      eventBus.unbind("ViewSourceMessageDialog.open", open);
    }
  }, [dialogStates, eventBus]);


  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={`${dialogStates.title} for ${dialogStates.record.uldNumber} received ${moment(dialogStates.record.eventTime).format("DD/MM/YYY HH:mm")}`}
        movable={true}
        message=""
        open={dialogStates.showDialog}
        record={__.cloneDeep(dialogStates.record)}
        dialogOptions={{width: "md", maxWidth: "md", fullWidth: true, height: 700}}
        classes={classes}
        buttons = {{
          cancel:{icon: "check_circle", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          setDialogStates({...dialogStates, showDialog: false, record: null});
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          {record => (
            <Grid item xs={12} checkChildren={true}>
              {
              isHTML(record.messageContent)
              ?
                <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                  <FormControl checkChildren={true} key="FC-message" style={{display: "block" }}>
                    <FormGroup checkChildren={true} key="FG-message" style={{padding: "8px 8px 8px 8px"}}>
                      <div style={{width: "100%", minHeight: 300, maxHeight: 440, overflowY: "scroll"}}>
                        <StringToJSX domString={record.messageContent}/>
                      </div>
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              :
                <TextField
                  id="messageContent"
                  value={record.messageContent}
                  multiline
                  variant={"outlined"}
                  inputProps={{readOnly:true, style:{height: "calc(100vh - 610px)", overflowY: "scroll", overflow: "hidden scroll", fontFamily: "monospace"  }}}
                  InputProps={{disableUnderline: true }}
                />
              }
              </Grid>
          )}
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default ViewSourceMessageDialog;
